// Copyright (c) Bentley Systems
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

type formChangedState = {
  isChanged: boolean;
  isValid: boolean;
  invokeChange: number;
  newFormAllValidNoChange: boolean;
}

const initialState: formChangedState = {
  isChanged: false,
  isValid: false,
  invokeChange: 0,
  newFormAllValidNoChange: false,
};

export const formChangedSlice = createSlice({
  name: "formChanged",
  initialState,
  reducers: {
    setFormChanged: (state, action: PayloadAction<boolean>) => {
      state.isChanged = action.payload;
    },
    setInvokeChange: (state) => {
      state.invokeChange += 1;
    },
    setFormValid: (state, action: PayloadAction<boolean>) => {
      state.isValid = action.payload;
    },
    /**e.g 'Activate/Deactivate all' form = 2 preselected dropdown - to enable 'Save' type buttons */
    setNewFormAllValidNoChange: (state, action: PayloadAction<boolean>) => {
      state.newFormAllValidNoChange = action.payload;
    },
  },
});

export const {
  setFormChanged,
  setFormValid,
  setInvokeChange,
  setNewFormAllValidNoChange,
} = formChangedSlice.actions;

export const selectFormChanged = (state: RootState) =>
  state.formChanged.isChanged;
export const selectFormValid = (state: RootState) => state.formChanged.isValid;
export const selectInvokeChange = (state: RootState) =>
  state.formChanged.invokeChange;
export const selectNewFormAllValidNoChange = (state: RootState) =>
  state.formChanged.newFormAllValidNoChange;

export default formChangedSlice.reducer;
